import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toHandlers as _toHandlers, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10483051"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white py-6" }
const _hoisted_2 = { class: "md:flex md:items-center md:justify-between sm:px-6 md:px-8" }
const _hoisted_3 = { class: "flex-1 min-w-0" }
const _hoisted_4 = { class: "text-2xl font-bold leading-7 text-gray-800 sm:text-3xl sm:truncate" }
const _hoisted_5 = { class: "mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 justify-center" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "flex flex-col sm:flex-row justify-start items-center gap-y-2" }
const _hoisted_8 = { class: "relative flex-grow" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "text-gray-600 w-4 h-full mx-2 absolute pointer-events-none",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" })
], -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex-shrink-0 m-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-4 h-4 stroke-current text-gray-600",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M14 5l7 7m0 0l-7 7m7-7H3"
    })
  ])
], -1))
const _hoisted_12 = { class: "relative flex-grow" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "text-gray-600 w-4 h-full mx-2 absolute pointer-events-none",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" })
], -1))
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  class: "bg-blue-500 hover:bg-blue-700 text-white font-bold ml-2 py-2 px-3 text-xs rounded",
  type: "submit"
}
const _hoisted_16 = {
  class: "analytics bg-white border-t border-gray-200 px-4 md:px-7",
  ref: "container",
  style: {"position":"relative"}
}
const _hoisted_17 = { class: "text-2xl font-bold leading-7 text-gray-800 mt-7 mb-4 sm:truncate" }
const _hoisted_18 = { class: "grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4" }
const _hoisted_19 = { class: "card green" }
const _hoisted_20 = { class: "key" }
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "ml-1" }
const _hoisted_23 = { class: "value-2" }
const _hoisted_24 = { class: "ml-1" }
const _hoisted_25 = { class: "card red" }
const _hoisted_26 = { class: "key" }
const _hoisted_27 = { class: "value" }
const _hoisted_28 = { class: "ml-1" }
const _hoisted_29 = { class: "value-2" }
const _hoisted_30 = { class: "ml-1" }
const _hoisted_31 = { class: "card gray" }
const _hoisted_32 = { class: "key" }
const _hoisted_33 = { class: "value" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "ml-1" }, "%", -1))
const _hoisted_35 = { class: "value-2" }
const _hoisted_36 = { class: "ml-1" }
const _hoisted_37 = { class: "card" }
const _hoisted_38 = { class: "key" }
const _hoisted_39 = { class: "value" }
const _hoisted_40 = { class: "ml-1" }
const _hoisted_41 = { class: "card" }
const _hoisted_42 = { class: "key" }
const _hoisted_43 = { class: "value" }
const _hoisted_44 = { class: "ml-1" }
const _hoisted_45 = { class: "card" }
const _hoisted_46 = { class: "key" }
const _hoisted_47 = { class: "value" }
const _hoisted_48 = { class: "ml-1" }
const _hoisted_49 = { class: "grid md:grid-cols-2 gap-4" }
const _hoisted_50 = { class: "md:w50 sm:w-auto" }
const _hoisted_51 = {
  class: "mt-4",
  ref: "depostiWithdrawCanvas"
}
const _hoisted_52 = { class: "md:w50 sm:w-auto" }
const _hoisted_53 = {
  class: "mt-4",
  ref: "sumDepositWithdrawCanvas"
}
const _hoisted_54 = { class: "text-2xl font-bold leading-7 text-gray-800 mt-7 mb-4 sm:truncate" }
const _hoisted_55 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" }
const _hoisted_56 = { class: "card blue" }
const _hoisted_57 = { class: "key" }
const _hoisted_58 = { class: "value" }
const _hoisted_59 = { class: "ml-1" }
const _hoisted_60 = { class: "card orange" }
const _hoisted_61 = { class: "key" }
const _hoisted_62 = { class: "value" }
const _hoisted_63 = { class: "ml-1" }
const _hoisted_64 = { class: "card purple" }
const _hoisted_65 = { class: "key" }
const _hoisted_66 = { class: "value" }
const _hoisted_67 = { class: "ml-1" }
const _hoisted_68 = {
  class: "mt-4",
  ref: "gameWinLossSummary"
}
const _hoisted_69 = { class: "text-2xl font-bold leading-7 text-gray-800 mt-7 mb-4 sm:truncate" }
const _hoisted_70 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" }
const _hoisted_71 = { class: "card c1" }
const _hoisted_72 = { class: "key" }
const _hoisted_73 = { class: "value" }
const _hoisted_74 = { class: "ml-1" }
const _hoisted_75 = { class: "card c2" }
const _hoisted_76 = { class: "key" }
const _hoisted_77 = { class: "value" }
const _hoisted_78 = { class: "ml-1" }
const _hoisted_79 = { class: "card c3" }
const _hoisted_80 = { class: "key" }
const _hoisted_81 = { class: "value" }
const _hoisted_82 = { class: "ml-1" }
const _hoisted_83 = { class: "grid md:grid-cols-2 gap-4" }
const _hoisted_84 = { class: "md:w50 sm:w-auto" }
const _hoisted_85 = {
  class: "mt-4",
  ref: "activeUserCanvas"
}
const _hoisted_86 = { class: "md:w50 sm:w-auto" }
const _hoisted_87 = {
  class: "mt-4",
  ref: "gameRoundCanvas"
}
const _hoisted_88 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" }
const _hoisted_89 = { class: "w50" }
const _hoisted_90 = { class: "text-xl pt-6 pb-4 font-bold leading-5 text-gray-800 sm:truncate" }
const _hoisted_91 = { cellspacing: "0" }
const _hoisted_92 = { style: {"text-align":"right"} }
const _hoisted_93 = { style: {"text-align":"right"} }
const _hoisted_94 = { class: "w50" }
const _hoisted_95 = { class: "text-xl pt-6 pb-4 font-bold leading-5 text-gray-800 sm:truncate" }
const _hoisted_96 = { cellspacing: "0" }
const _hoisted_97 = { style: {"text-align":"right"} }
const _hoisted_98 = { style: {"text-align":"right"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_date_picker = _resolveComponent("v-date-picker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("messages.dashboard.dashboard")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("form", {
              class: "",
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.getAnalyticData()), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_v_date_picker, {
                  modelValue: _ctx.range,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.range) = $event)),
                  mode: "date",
                  "min-date": _ctx.minDate,
                  "max-date": _ctx.maxDate,
                  masks: _ctx.masks,
                  "is-range": ""
                }, {
                  default: _withCtx(({ inputValue, inputEvents, isDragging }) => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("input", _mergeProps({
                          class: ["flex-grow pl-8 pr-2 py-1 bg-gray-100 border rounded w-full", isDragging ? 'text-gray-600' : 'text-gray-900'],
                          value: inputValue.start
                        }, _toHandlers(inputEvents.start)), null, 16, _hoisted_10)
                      ]),
                      _hoisted_11,
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("input", _mergeProps({
                          class: ["flex-grow pl-8 pr-2 py-1 bg-gray-100 border rounded w-full", isDragging ? 'text-gray-600' : 'text-gray-900'],
                          value: inputValue.end
                        }, _toHandlers(inputEvents.end)), null, 16, _hoisted_14)
                      ]),
                      _createElementVNode("button", _hoisted_15, _toDisplayString(_ctx.$t("messages.dashboard.apply")), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "min-date", "max-date", "masks"])
              ])
            ], 32)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("h2", _hoisted_17, _toDisplayString(_ctx.$t("messages.dashboard.incomeSummary")), 1),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("messages.dashboard.totalDeposit")), 1),
          _createElementVNode("span", _hoisted_21, [
            _createTextVNode(_toDisplayString(_ctx.totalDepositUsers.toLocaleString("us", { maximumFractionDigits: 2 })) + " ", 1),
            _createElementVNode("small", _hoisted_22, _toDisplayString(_ctx.$t("messages.dashboard.Transactions")), 1)
          ]),
          _createElementVNode("span", _hoisted_23, [
            _createTextVNode(_toDisplayString((_ctx.totalDeposit / 100).toLocaleString("us", {
              maximumFractionDigits: 2,
            })) + " ", 1),
            _createElementVNode("small", _hoisted_24, _toDisplayString(_ctx.$t("messages.dashboard.thb")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("messages.dashboard.totalWithdraw")), 1),
          _createElementVNode("span", _hoisted_27, [
            _createTextVNode(_toDisplayString(_ctx.totalWithdrawUsers.toLocaleString("us", {
              maximumFractionDigits: 2,
            })) + " ", 1),
            _createElementVNode("small", _hoisted_28, _toDisplayString(_ctx.$t("messages.dashboard.Transactions")), 1)
          ]),
          _createElementVNode("span", _hoisted_29, [
            _createTextVNode(_toDisplayString((_ctx.totalWithdraw / 100).toLocaleString("us", {
              maximumFractionDigits: 2,
            })) + " ", 1),
            _createElementVNode("small", _hoisted_30, _toDisplayString(_ctx.$t("messages.dashboard.thb")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("messages.dashboard.estimateProfit")), 1),
          _createElementVNode("span", _hoisted_33, [
            _createTextVNode(_toDisplayString(_ctx.totalLossPlayers? _ctx.totalLossPlayers.toLocaleString("us", { maximumFractionDigits: 2 }): 0) + " ", 1),
            _hoisted_34
          ]),
          _createElementVNode("span", _hoisted_35, [
            _createTextVNode(_toDisplayString((_ctx.estimatedProfit / 100).toLocaleString("us", {
              maximumFractionDigits: 2,
            })) + " ", 1),
            _createElementVNode("small", _hoisted_36, _toDisplayString(_ctx.$t("messages.dashboard.thb")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t("messages.dashboard.totalPlayerBonus")), 1),
          _createElementVNode("span", _hoisted_39, [
            _createTextVNode(_toDisplayString((_ctx.totalBonus / 100).toLocaleString("us", {
              maximumFractionDigits: 2,
            })) + " ", 1),
            _createElementVNode("small", _hoisted_40, _toDisplayString(_ctx.$t("messages.dashboard.thb")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t("messages.dashboard.calimedCommissions")), 1),
          _createElementVNode("span", _hoisted_43, [
            _createTextVNode(_toDisplayString((_ctx.claimedCommission / 100).toLocaleString("us", {
              maximumFractionDigits: 2,
            })) + " ", 1),
            _createElementVNode("small", _hoisted_44, _toDisplayString(_ctx.$t("messages.dashboard.thb")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t("messages.dashboard.calimedAffiliate")), 1),
          _createElementVNode("span", _hoisted_47, [
            _createTextVNode(_toDisplayString((_ctx.claimedAffiliate / 100).toLocaleString("us", {
              maximumFractionDigits: 2,
            })) + " ", 1),
            _createElementVNode("small", _hoisted_48, _toDisplayString(_ctx.$t("messages.dashboard.thb")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_49, [
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("canvas", _hoisted_51, null, 512)
        ]),
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("canvas", _hoisted_53, null, 512)
        ])
      ]),
      _createElementVNode("h2", _hoisted_54, _toDisplayString(_ctx.$t("messages.dashboard.gameplayStatistics")), 1),
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.$t("messages.dashboard.estimatedBet")), 1),
          _createElementVNode("span", _hoisted_58, [
            _createTextVNode(_toDisplayString((_ctx.totalBets / 100).toLocaleString("us", { maximumFractionDigits: 2 })) + " ", 1),
            _createElementVNode("small", _hoisted_59, _toDisplayString(_ctx.$t("messages.dashboard.thb")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.$t("messages.dashboard.estimatePlayerWin")), 1),
          _createElementVNode("span", _hoisted_62, [
            _createTextVNode(_toDisplayString((_ctx.totalPlayerWin / 100).toLocaleString("us", {
              maximumFractionDigits: 2,
            })) + " ", 1),
            _createElementVNode("small", _hoisted_63, _toDisplayString(_ctx.$t("messages.dashboard.thb")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.$t("messages.dashboard.estimatedWinLoss")), 1),
          _createElementVNode("span", _hoisted_66, [
            _createTextVNode(_toDisplayString((_ctx.totalWinLoss / 100).toLocaleString("us", {
              maximumFractionDigits: 2,
            })) + " ", 1),
            _createElementVNode("small", _hoisted_67, _toDisplayString(_ctx.$t("messages.dashboard.thb")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("canvas", _hoisted_68, null, 512)
      ]),
      _createElementVNode("h2", _hoisted_69, _toDisplayString(_ctx.$t("messages.dashboard.playerStatistic")), 1),
      _createElementVNode("div", _hoisted_70, [
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.$t("messages.dashboard.newUsers")), 1),
          _createElementVNode("span", _hoisted_73, [
            _createTextVNode(_toDisplayString(_ctx.totalNewUsers) + " ", 1),
            _createElementVNode("small", _hoisted_74, _toDisplayString(_ctx.$t("messages.dashboard.users")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_75, [
          _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.$t("messages.dashboard.averageActiveUsersPerHour")), 1),
          _createElementVNode("span", _hoisted_77, [
            _createTextVNode(_toDisplayString(_ctx.totalActiveUsers.toLocaleString("us", { maximumFractionDigits: 2 })) + " ", 1),
            _createElementVNode("small", _hoisted_78, _toDisplayString(_ctx.$t("messages.dashboard.users")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_79, [
          _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.$t("messages.dashboard.gameRounds")), 1),
          _createElementVNode("span", _hoisted_81, [
            _createTextVNode(_toDisplayString(_ctx.totalGameRounds.toLocaleString("us", { maximumFractionDigits: 2 })) + " ", 1),
            _createElementVNode("small", _hoisted_82, _toDisplayString(_ctx.$t("messages.dashboard.rounds")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_83, [
        _createElementVNode("div", _hoisted_84, [
          _createElementVNode("canvas", _hoisted_85, null, 512)
        ]),
        _createElementVNode("div", _hoisted_86, [
          _createElementVNode("canvas", _hoisted_87, null, 512)
        ])
      ]),
      _createElementVNode("div", _hoisted_88, [
        _createElementVNode("div", _hoisted_89, [
          _createElementVNode("h2", _hoisted_90, _toDisplayString(_ctx.$t("messages.dashboard.mostProfitableGame")), 1),
          _createElementVNode("div", null, [
            _createElementVNode("table", _hoisted_91, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("messages.dashboard.game")), 1),
                  _createElementVNode("th", _hoisted_92, " #" + _toDisplayString(_ctx.$t("messages.dashboard.rank")), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalActiveUserPerGame, (game, i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                    _createElementVNode("td", null, _toDisplayString(game.name), 1),
                    _createElementVNode("td", _hoisted_93, _toDisplayString(i + 1), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_94, [
          _createElementVNode("h2", _hoisted_95, _toDisplayString(_ctx.$t("messages.dashboard.mostPopularGame")), 1),
          _createElementVNode("div", null, [
            _createElementVNode("table", _hoisted_96, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("messages.dashboard.game")), 1),
                  _createElementVNode("th", _hoisted_97, _toDisplayString(_ctx.$t("messages.dashboard.averageActivePlayers")), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalGameRoundPerGame, (game, i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                    _createElementVNode("td", null, _toDisplayString(game.name), 1),
                    _createElementVNode("td", _hoisted_98, _toDisplayString(game.count.toLocaleString("us", {
                      maximumFractionDigits: 2,
                    })), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ], 512)
  ], 64))
}